var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      enableBackground: "new 0 0 1122 1122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#EFF4F2;}\r\n\t.st2{fill:#009E7E;}\r\n\t.st3{fill:#EDF9F5;}\r\n\t.st4{fill:#F7F7F7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1122,
    height: 1122
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.8,531.8c-8.1,0-15.8-3.2-21.5-8.9l-41.7-41.7H271.8v55.2h578.3v-55.2H719.7L678,522.9 c-5.7,5.7-13.4,8.9-21.5,8.9c-8.1,0-15.8-3.2-21.5-8.9c-11.5-11.5-11.7-29.8-1-41.7H487.3c5,5.6,7.9,12.7,7.9,20.2 c0,8.1-3.2,15.8-8.9,21.5C480.6,528.7,472.9,531.8,464.8,531.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243,452.3c-3.2,3.2-5,7.5-5,12v89c0,4.5,1.8,8.8,5,12c3.2,3.2,7.5,5,12,5h36.9l60.7,252.5 c2.6,10.9,12.4,18.5,23.5,18.5h375.8c11.2,0,20.9-7.6,23.5-18.5l61.3-252.6h30.6c4.5,0,8.8-1.8,12-5c3.1-3.1,5-7.5,5-12v-89 c0-4.5-1.8-8.8-5-12c-3.2-3.2-7.5-5-12-5H753.5l114.8-114.8c5.7-5.7,8.9-13.4,8.9-21.5c0-8.1-3.2-15.8-8.9-21.5 c-5.7-5.8-13.4-8.9-21.5-8.9c-8.1,0-15.8,3.2-21.5,8.9L667.6,447.4H453.7L296,289.6c-5.7-5.8-13.4-8.9-21.5-8.9 c-8.1,0-15.7,3.2-21.5,8.9c-5.7,5.8-8.9,13.4-8.9,21.5c0,8.1,3.2,15.8,8.9,21.5l114.8,114.8H254.9 C250.5,447.4,246.1,449.2,243,452.3z M424.7,733c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.5-12.4-12.4V601.6 c0-6.8,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4V733z M573.4,757.6c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.5-12.4-12.4v-156 c0-6.8,5.5-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4V757.6z M722.1,733c0,6.9-5.6,12.4-12.4,12.4c-6.9,0-12.4-5.5-12.4-12.4V601.6 c0-6.8,5.6-12.4,12.4-12.4c6.8,0,12.4,5.6,12.4,12.4V733z M271.8,481.2h129.8l41.7,41.7c5.7,5.7,13.4,8.9,21.5,8.9 c8.1,0,15.8-3.2,21.5-8.9c5.7-5.7,8.9-13.4,8.9-21.5c0-7.6-2.9-14.7-7.9-20.2H634c-10.7,11.9-10.4,30.3,1,41.7 c5.7,5.7,13.4,8.9,21.5,8.9c8.1,0,15.7-3.2,21.5-8.9l41.7-41.7h130.5v55.2H271.8V481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M548.6,601.6v156c0,6.9,5.5,12.4,12.4,12.4c6.9,0,12.4-5.5,12.4-12.4v-156c0-6.8-5.6-12.4-12.4-12.4 C554.1,589.2,548.6,594.8,548.6,601.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.9,601.6V733c0,6.9,5.6,12.4,12.4,12.4c6.9,0,12.4-5.5,12.4-12.4V601.6c0-6.8-5.6-12.4-12.4-12.4 C405.5,589.2,399.9,594.8,399.9,601.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M697.3,601.6V733c0,6.9,5.6,12.4,12.4,12.4c6.8,0,12.4-5.5,12.4-12.4V601.6c0-6.8-5.6-12.4-12.4-12.4 C702.9,589.2,697.3,594.8,697.3,601.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanier);
export default __webpack_public_path__ + "static/media/panier.3a940eb20fe907385633b684e6b2d3c6.svg";
export { ForwardRef as ReactComponent };